import { ACTION } from "@/types/global";
import { SidebarItem } from "@/types/user.types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PageEvent {
  type: "refresh";
  keys: string[];
}
interface DashboardState {
  sideBars: SidebarItem[];
  activeSideBarKey: string | null;
  routeSegments: string[];
  action: ACTION;
  isSideBarExpanded: boolean;
  pageEvent: null | PageEvent;
}

const initialState: DashboardState = {
  sideBars: [],
  activeSideBarKey: null,
  routeSegments: [],
  action: "",
  isSideBarExpanded: false,
  pageEvent: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setActiveSideBarKey: (state, action: PayloadAction<string>) => {
      state.activeSideBarKey = action.payload;
    },
    setSideBars: (state, action: PayloadAction<SidebarItem[]>) => {
      state.sideBars = action.payload;
    },
    setRouteSegment: (state, action: PayloadAction<string[]>) => {
      state.routeSegments = action.payload;
    },
    setFormAction: (state, action: PayloadAction<ACTION>) => {
      state.action = action.payload;
    },
    setPageEvent: (state, action: PayloadAction<PageEvent | null>) => {
      state.pageEvent = action.payload;
    },
    toggleSideBarExpended: (state) => {
      state.isSideBarExpanded = !state.isSideBarExpanded;
    },
    resetDashboard: () => initialState,
  },
});

export const { setActiveSideBarKey, setSideBars, setRouteSegment, resetDashboard, setFormAction, toggleSideBarExpended, setPageEvent } = dashboardSlice.actions;
// selectors
export const dashboardSelector = (state: any) => state.dashboard as DashboardState;
export const pageEventSelector = (state: any) => state.dashboard.pageEvent as PageEvent;

export const activeSideBarSelector = (state: any) => {
  const dashboard = state.dashboard as DashboardState;
  return dashboard.sideBars.find((item) => item.key === dashboard.activeSideBarKey);
};

export default dashboardSlice.reducer;
